import { createContext, useContext } from "react"

import { ProductInformation } from "shared/types/__generated__/graphql"

export interface ProductTenderTextContextValue {
  productInformation: ProductInformation | null | undefined
  isLoading: boolean
  copyToClipboard: () => void
}

export const ProductTenderTextContext =
  createContext<ProductTenderTextContextValue | null>(null)

export function useProductTenderTextContext(): ProductTenderTextContextValue {
  const ctx = useContext(ProductTenderTextContext)
  if (!ctx) {
    throw new Error(
      "useProductTenderTextContext must be used within ProductTenderText.Root"
    )
  }
  return ctx
}
